import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWeight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWeight"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM12 7C9.72995 7 7.64384 7.78771 6 9.10449L9 12.8545C9.82192 12.1961 10.865 11.8018 12 11.8018C13.135 11.8018 14.1781 12.1961 15 12.8545L18 9.10449C16.3562 7.78771 14.2701 7 12 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWeight;
